/**
 * メニューが「在庫0（売り切れ）」かどうかの判定（ODR-1629）。
 *
 * ホール側 Order.vue の isStatus やお客様側の SOLDOUT 表示と同じ不変条件:
 *  - 手動 SOLDOUT フラグ(is_soldout) が立っている
 *  - もしくは 個数制限あり(is_set_maximum_order_per_day) かつ 残数(remain_order) が 0 以下
 *
 * DOM や Vue に依存しない純粋関数なので、そのままユニットテストできる。
 */
export interface MenuStock {
  /** 手動 SOLDOUT フラグ */
  is_soldout: boolean;
  /** 1日の個数制限を使うか */
  is_set_maximum_order_per_day: boolean;
  /** 残り注文可能数 */
  remain_order: number;
}

export function isMenuSoldout(menu: MenuStock): boolean {
  if (menu.is_soldout === true) {
    return true;
  }
  if (menu.is_set_maximum_order_per_day === true && menu.remain_order < 1) {
    return true;
  }
  return false;
}

/**
 * この注文数(quantity)が在庫を超えるか（ODR-1629）。
 * 「売り切れ(0)」だけでなく「残5個に対して8個」のような数量超過も検出する。
 *  - 手動 SOLDOUT フラグが立っている → true
 *  - 個数制限あり かつ 残数 < 注文数 → true（残数ちょうどは false）
 * 個数制限なしのメニューは在庫無制限扱いで常に false。
 */
export function exceedsRemainOrder(menu: MenuStock, quantity: number): boolean {
  if (menu.is_soldout === true) {
    return true;
  }
  if (menu.is_set_maximum_order_per_day === true && menu.remain_order < quantity) {
    return true;
  }
  return false;
}
